export default "__VITE_ASSET__CVlvs7Fp__"